var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighDemand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0475 5.8125L5.34996 13.81C5.27444 13.8996 5.17124 13.9614 5.05665 13.9859C4.94206 14.0103 4.8226 13.9958 4.71713 13.9448C4.61166 13.8938 4.52618 13.8091 4.47418 13.7041C4.42218 13.5991 4.40662 13.4798 4.42996 13.365L5.47996 8.335L5.45496 8.3025H1.35746C1.25832 8.30254 1.16119 8.27454 1.07728 8.22175C0.993365 8.16895 0.926093 8.0935 0.883226 8.00411C0.840359 7.91471 0.823644 7.81502 0.835009 7.71653C0.846374 7.61805 0.885357 7.52478 0.947458 7.4475L6.75996 0.1975C6.80871 0.136113 6.87065 0.0864862 6.9412 0.0522972C7.01174 0.0181082 7.08907 0.000234168 7.16746 0C7.2406 0.000485475 7.31289 0.0157937 7.37996 0.045C7.48625 0.0904388 7.57453 0.169752 7.63105 0.270587C7.68757 0.371422 7.70916 0.488118 7.69246 0.6025L7.06746 4.9425L7.09496 4.9725L11.64 4.9475H11.6425C11.7428 4.94736 11.841 4.97585 11.9257 5.02962C12.0103 5.08338 12.0779 5.16019 12.1204 5.25102C12.163 5.34185 12.1787 5.44294 12.1658 5.54239C12.1528 5.64185 12.1118 5.73556 12.0475 5.8125Z",
    fill: "url(#paint0_linear_2885_9508)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2885_9508",
    x1: 0.830208,
    y1: 7,
    x2: 12.1705,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A93AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighDemand);
export default __webpack_public_path__ + "static/media/high-demand.54c9baaf72121bfcfc0fb4ad3dcf214f.svg";
export { ForwardRef as ReactComponent };